export const API_URL = process.env.API_URL;
export const APP_VERSION = process.env.APP_VERSION;
export const TERMS_URL = process.env.TERMS_URL;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const STRIPE_PUBLIC_KEY = process.env.STRIPE_PUBLIC_KEY;
export const ENCRYPT_KEY = process.env.ENCRYPT_KEY;
export const STOREFRONT_USER_PROFILE_URL =
  process.env.STOREFRONT_USER_PROFILE_URL;
